/* globals VXConfig */
import React              from 'react';
import PropTypes          from 'prop-types';
import Flux               from '../../flux/Flux';
import Translations       from '../../utils/Translations';
import ReloadHelper       from '../../utils/ReloadHelper';
import {VXPay}            from '../../utils/VXPay';
import UrlBuilder         from '../../utils/UrlBuilder';
import ContentLink                 from './SubComponents/ContentLink';
import DailyBonusOfferBtn          from './SubComponents/DailyBonusOfferBtn';
import OfferIcon                   from './SubComponents/OfferIcon';
import VipBadge                    from './SubComponents/VipBadge';
import {
	getTopUpGteThenValue,
	formatEffectAsPlainText,
	isMerchAndHasCode,
	needVipYesterdayOffer,
	isCurrencyVoucher,
}                                  from './dailyBonusHelpers';
import {VXButtonLineConfig}        from "../SimpleElements/VXButton/VXButtonConfig";
import STYLES                      from "../SimpleElements/VXButton/EnumVXButton";
import VXButtonOutline             from "../SimpleElements/VXButton/Presets/VXButtonOutline";
import AlbumPriceLabel from './SubComponents/AlbumPriceLabel';
import {getCurrencySymbol}         from '../../utils/CommonUtils.js';

const {offers, offerBgs} = Flux.Constants.DailyBonuses;

class DailybonusYestardayItem extends React.Component {

	constructor(props) {
		super(props);
		const {
			      conditions = [],
			      free       = false,
			      offer,
		      }            = this.props.data;
		let {content = {}} = this.props.data;
		const needsVip     = needVipYesterdayOffer(conditions);
		let preview        = [];
		let header2Level   = Translations.get('YearstadayBonusContentTitle_' + offer);

		if (null === content) {
			content = {};
		}

		switch (offer) {
			case offers.VIP:
				if (Flux.Guest.isVip()) {
					preview = [content.wPreview ? content.wPreview : '/assets/img/placeholder.jpg'];
				} else {
					preview      = [offerBgs.VIP];
					header2Level = Translations.get('ForOneDay365');
				}
				break;
			case offers.MESSENGER_GIFT:
				preview = [offerBgs.MESSENGER_GIFT];

				if (conditions.length > 0) {
					header2Level = Translations.get('YearstadayBonusContentTitle_MessengerGift')
						.replace(':value', conditions[0].value)
						.replace(':currency', getCurrencySymbol());
				}
				break;
			case offers.VIDEO_VOUCHER:
				preview      = [offerBgs.VIDEO_VOUCHER];
				header2Level = Translations.get('VideoVoucher') + ' ' + Translations.get('MessengerGift365Minimum', getTopUpGteThenValue(conditions)) + ' ' + getCurrencySymbol();
				break;
			case offers.PHOTO_ALBUM:
				const photos = content.photos ? content.photos : [{url: '/assets/img/placeholder.jpg'}];
				preview      = photos.slice(0, 4).map(img => img.url);

				if (free) {
					header2Level = Translations.get('YearstadayBonusContentTitleFree_photo_album');
				}
				break;

			case offers.VIDEO:
				preview = [content.preview ? content.preview.url : '/assets/img/placeholder.jpg'];

				if (free) {
					header2Level = Translations.get('YearstadayBonusContentTitleFree_video');
				}
				break;
			default:
		}

		this.state = {
			needVipYesterdayOffer: needsVip,
			showPreview:           needsVip ? Flux.Guest.isVip() : true,
			preview:               preview,
			showBlur:              needsVip ? !Flux.Guest.isVip() : false,
			header2Level:          header2Level,
			showActorLink:         content.model && content.model.name && (offer === offers.VIDEO || offer === offers.PHOTO_ALBUM),
		};

		this.onBecomeVipBtnClicked = this.onBecomeVipBtnClicked.bind(this);
		this.onClickUrlHandler     = this.onClickUrlHandler.bind(this);
		this.getHeader1Level       = this.getHeader1Level.bind(this);
	}

	getHeader1Level() {
		const {
			      effect,
			      free = false,
			      offer,
				  quantity,
			  } = this.props.data;
		switch (offer) {
			case offers.MESSENGER_GIFT:
				const content                    = this.props.data.content ? this.props.data.content : {};
				const {imageUrl = '', name = ''} = content;
				return (
					<div className='dailybonus-yestarday-item__content--bonus-wrapper'>
						<img className='dailybonus-yestarday-item__content--bonus-wrapper__img'
						     src={imageUrl}
						     alt={name}
							 loading={this.props.lazyImageLoading ? 'lazy' : 'eager'}
						/>
						{quantity &&
						<span className="dailybonus-yestarday-item__content--bonus-wrapper__quantity">{quantity}</span>}
					</div>
				);
			case offers.VIDEO_VOUCHER:
				return (
					<div className="dailybonus-yestarday-item__content__discount -is-voucher h-text-uppercase">
						<span className='dailybonus-yestarday-item__content__discount--icon'>
							<i className='icon -icon-voucher-icon ' />
							{quantity &&
							<span className="dailybonus-yestarday-item__content__discount--icon--quantity">{quantity}x</span>}
						</span>
					</div>
				);
			default:
				break;
		}

		let lbl = '';
		if (offer === offers.VIP && !Flux.Guest.isVip()) {
			lbl = 'VIP';
		} else if (free || offer === offers.VIP) {
			lbl = Translations.get('Free');
		} else if (effect) {
			lbl = formatEffectAsPlainText(effect);
		}

		return (
			<div className={'dailybonus-yestarday-item__content__discount' + (free ? ' -is-free' : '')}>
				{lbl}
			</div>
		);
	}

	onBecomeVipBtnClicked(e) {
		e.preventDefault();
		if (!Flux.Guest.isLoggedIn()) {
			VXPay.openLogin();
			return;
		}
		VXPay.openAboPaytour();
	}

	onClickUrlHandler(e) {
		ReloadHelper.reload(e.currentTarget.href, e);
	}

	render() {
		//const {pm}              = this.props;
		const {
			      content, effect, offer, purchased, free,
		      }                 = this.props.data;
		const {
			      showPreview, preview, showBlur, needVipYesterdayOffer, header2Level, showActorLink,
		      }                 = this.state;
		const {
			      hidden,
			      linkVX,
				  model,
				  price,
				  basePrice,
				  dailyBonusPrice,
		      }                 = content || {};
		const microsoftBrowsers = Flux.Browser.isIE() || Flux.Browser.isEdge() ? ' ie' : '';
		const isVoucher         = offer === offers.VIDEO_VOUCHER;
		const itemClasses       = ['dailybonus-yestarday-item'];
		isMerchAndHasCode(offer, effect) && itemClasses.push('-has-code');
		let header3Level = offer === offers.VIP ? '' : (content && content.title);
		if (offer === offers.VIDEO || offer === offers.PHOTO_ALBUM) {
			header3Level = (
				<ContentLink link={linkVX} enabled={!hidden || purchased}>
					{header3Level}
				</ContentLink>
			);
		}

		return (
			<div className={itemClasses.join(' ')}>
				<h3 className="dailybonus-yestarday-item__headline">{Translations.get('YearstadayBonusTitle')}</h3>
				<div className="dailybonus-yestarday-item__headline -small">{Translations.get('YearstadayBonusTitleShort')}</div>
				<div className="dailybonus-yestarday-item__wrapper">
					{
						showPreview && preview &&
						<div className='dailybonus-yestarday-item__background'>
							{
								preview.map((img, index) => (
									<div key={index}
									     className={preview.length === 4 ? 'img-grid' : 'img-full'}
									     style={{backgroundImage: `url(${img})`}}
									/>
								))
							}
						</div>
					}
					<div className={'dailybonus-yestarday-item__content ' + (showBlur ? ('blur' + microsoftBrowsers) : '')}>
						<VipBadge show={needVipYesterdayOffer} />
						{this.getHeader1Level()}
						<div className={'dailybonus-yestarday-item__content__title' + (isVoucher ? ' -is-voucher' : '')}>
							{header2Level}
							{
								showActorLink && (
									<a onClick={this.onClickUrlHandler}
									   href={UrlBuilder.buildActorProfileUrl(model.name)}
									> {model.name}</a>
								)
							}
						</div>
						<div className={"dailybonus-yestarday-item__content__description" + (content && !free ? ' dailybonus-yestarday-item__content__description--price' : '')}>{header3Level}</div>
						{content && !free && (<AlbumPriceLabel price={price} basePrice={basePrice} discountedPrice={dailyBonusPrice} purchased={purchased} additionalClass="dailybonus-yestarday-item__content__price" />)}
						<DailyBonusOfferBtn {...this.props.data} btnClassName='dailybonus-yestarday-item__content__offer-btn'
						                    wallpaperBtnPostfix='-size-half'
							topLevelClass='dailybonus-yestarday-item__action-btn'
							isOutlineButton={true}
							isCurrencyVoucher={isCurrencyVoucher(price)}
						/>
						<div className="dailybonus-yestarday-item__content__offer-icon">
							<OfferIcon offer={isVoucher ? offers.MESSENGER_GIFT : offer} purchased={purchased} />
						</div>
					</div>
					{
						showBlur &&
						<div className='dailybonus-yestarday-item__not-vip-overlay'>
							<div className="dailybonus-yestarday-item__not-vip-overlay__icon"><i className='icon -icon-person-vip' /></div>
							<div className="dailybonus-yestarday-item__not-vip-overlay__text">{Translations.get('YearstadayBonusNotVIPYet')}</div>
							<div className="dailybonus-yestarday-item__not-vip-overlay__btn-wrapper">
								<VXButtonOutline
									line1={[new VXButtonLineConfig(Translations.get('YearstadayBonusBecomeVIP'))]}
									onClick={this.onBecomeVipBtnClicked}
									size={VXConfig.device.isTablet ? STYLES.SIZE.TINY : STYLES.SIZE.SMALL}
								/>
							</div>
						</div>
					}
				</div>
			</div>
		);
	}
}

DailybonusYestardayItem.propTypes = {
	data: PropTypes.shape({
		offer:      PropTypes.string,
		purchased:  PropTypes.bool,
		free:       PropTypes.bool,
		price:      PropTypes.shape({
			vale:     PropTypes.number,
			currency: PropTypes.string,
		}),
		quantity:   PropTypes.number,
		content:    PropTypes.shape({
			id:           PropTypes.any,
			mobile:       PropTypes.any,
			translations: PropTypes.any,
			preview:      PropTypes.object,
			wPreview:     PropTypes.string,
			title:        PropTypes.string,
			imageUrl:     PropTypes.string,
			name:         PropTypes.string,
			price:        PropTypes.object,
			photos:       PropTypes.any,
			model:        PropTypes.shape({
				name: PropTypes.string,
			}),
		}),
		conditions: PropTypes.arrayOf(PropTypes.shape({
			value: PropTypes.any,
		})),
		effect:     PropTypes.shape({
			code:  PropTypes.string,
			value: PropTypes.string,
			unit:  PropTypes.string,
		}),
	}).isRequired,
	lazyImageLoading: PropTypes.bool,
};

DailybonusYestardayItem.defaultProps = {
	lazyImageLoading: true,
};

export default DailybonusYestardayItem;
